import { render, staticRenderFns } from "./upload-csv.vue?vue&type=template&id=3b478948&"
import script from "./upload-csv.vue?vue&type=script&lang=js&"
export * from "./upload-csv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports